import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";

// Auth
import Login from "./pages/auth/Login";
import MotDePasseOublie from "./pages/auth/MotDePasseOublie";
import ResetPassword from "./pages/auth/ResetPassword";

// Commercial
import DashboardCommercial from "./pages/commercial/DashboardCommercial";
import Clients from "./pages/commercial/Clients";
import FicheClient from "./pages/commercial/FicheClient";
import Alertes from "./pages/commercial/Alertes";
import Historique from "./pages/commercial/Historique";

// Superviseur
import DashboardSuperviseur from "./pages/superviseur/DashboardSuperviseur";
import CommerciauxSuperviseur from "./pages/superviseur/Commerciaux";
import ClientsSuperviseur from "./pages/superviseur/ClientsSuperviseur";
import AlertesSuperviseur from "./pages/superviseur/AlertesSuperviseur";
import HistoriqueSuperviseur from "./pages/superviseur/HistoriqueSuperviseur";
import Recapitulatif from "./pages/superviseur/Recapitulatif";
import StatistiquesSuperviseur from "./pages/superviseur/Statistiquessuperviseur";

// Admin
import AdminLayout from "./components/layouts/AdminLayout";
import DashboardAdmin from "./pages/admin/DashboardAdmin";
import Superviseurs from "./pages/admin/Superviseurs";
import CommerciauxAdmin from "./pages/admin/Commerciaux";
import FicheCommercial from "./pages/admin/FicheCommercial";
import Archivage from "./pages/admin/Archivage";
import ClientsAdmin from "./pages/admin/ClientsAdmin";
import RecapitulatifAdmin from "./pages/admin/Recapitulatif";
import Produits from "./pages/admin/Produits";
import StatistiquesAdmin from "./pages/admin/Statistiquesadmin";
import Profil from "./pages/Profil";

function PrivateRoute({ children, roles }) {
  const { utilisateur, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ width: "36px", height: "36px", border: "3px solid #E6F1FB", borderTop: "3px solid #185FA5", borderRadius: "50%", animation: "spin 1s linear infinite" }} />
      </div>
    );
  }

  if (!utilisateur) return <Navigate to="/login" replace />;

  if (roles && !roles.includes(utilisateur.role)) {
    if (utilisateur.role === "Administrateur") return <Navigate to="/admin/dashboard" replace />;
    if (utilisateur.role === "Superviseur")    return <Navigate to="/superviseur/dashboard" replace />;
    if (utilisateur.role === "Commercial")     return <Navigate to="/commercial/dashboard" replace />;
  }

  return children;
}

export default function AppRoutes() {
  const { utilisateur } = useAuth();

  return (
    <Routes>
      <Route
        path="/"
        element={
          utilisateur
            ? <Navigate to={
                utilisateur.role === "Administrateur" ? "/admin/dashboard" :
                utilisateur.role === "Superviseur"    ? "/superviseur/dashboard" :
                "/commercial/dashboard"
              } replace />
            : <Navigate to="/login" replace />
        }
      />

      {/* Auth */}
      <Route path="/login" element={<Login />} />
      <Route path="/mot-de-passe-oublie" element={<MotDePasseOublie />} />
      <Route path="/reinitialiser-mdp" element={<ResetPassword />} />

      {/* Admin */}
      <Route path="/admin/dashboard" element={<PrivateRoute roles={["Administrateur"]}><AdminLayout><DashboardAdmin /></AdminLayout></PrivateRoute>} />
      <Route path="/admin/superviseurs" element={<PrivateRoute roles={["Administrateur"]}><AdminLayout><Superviseurs /></AdminLayout></PrivateRoute>} />
      <Route path="/admin/commerciaux" element={<PrivateRoute roles={["Administrateur"]}><AdminLayout><CommerciauxAdmin /></AdminLayout></PrivateRoute>} />
      <Route path="/admin/commerciaux/:id" element={<PrivateRoute roles={["Administrateur"]}><AdminLayout><FicheCommercial /></AdminLayout></PrivateRoute>} />
      <Route path="/admin/clients" element={<PrivateRoute roles={["Administrateur"]}><AdminLayout><ClientsAdmin /></AdminLayout></PrivateRoute>} />
      <Route path="/admin/archivage" element={<PrivateRoute roles={["Administrateur"]}><AdminLayout><Archivage /></AdminLayout></PrivateRoute>} />
      <Route path="/admin/recapitulatif" element={<PrivateRoute roles={["Administrateur"]}><AdminLayout><RecapitulatifAdmin /></AdminLayout></PrivateRoute>} />
      <Route path="/admin/produits" element={<PrivateRoute roles={["Administrateur"]}><AdminLayout><Produits /></AdminLayout></PrivateRoute>} />
      <Route path="/admin/statistiques" element={<PrivateRoute roles={["Administrateur"]}><AdminLayout><StatistiquesAdmin /></AdminLayout></PrivateRoute>} />
      

      {/* Superviseur */}
      <Route path="/superviseur/dashboard" element={<PrivateRoute roles={["Superviseur"]}><DashboardSuperviseur /></PrivateRoute>} />
      <Route path="/superviseur/commerciaux" element={<PrivateRoute roles={["Superviseur"]}><CommerciauxSuperviseur /></PrivateRoute>} />
      <Route path="/superviseur/clients" element={<PrivateRoute roles={["Superviseur"]}><ClientsSuperviseur /></PrivateRoute>} />
      <Route path="/superviseur/alertes" element={<PrivateRoute roles={["Superviseur"]}><AlertesSuperviseur /></PrivateRoute>} />
      <Route path="/superviseur/historique" element={<PrivateRoute roles={["Superviseur"]}><HistoriqueSuperviseur /></PrivateRoute>} />
      <Route path="/superviseur/recapitulatif" element={<PrivateRoute roles={["Superviseur"]}><Recapitulatif /></PrivateRoute>} />
      <Route path="/superviseur/statistiques" element={<PrivateRoute roles={["Superviseur"]}><StatistiquesSuperviseur /></PrivateRoute>} />

      {/* Commercial */}
      <Route path="/commercial/dashboard" element={<PrivateRoute roles={["Commercial"]}><DashboardCommercial /></PrivateRoute>} />
      <Route path="/commercial/clients" element={<PrivateRoute roles={["Commercial"]}><Clients /></PrivateRoute>} />
      <Route path="/commercial/clients/:id" element={<PrivateRoute roles={["Commercial"]}><FicheClient /></PrivateRoute>} />
      <Route path="/commercial/alertes" element={<PrivateRoute roles={["Commercial"]}><Alertes /></PrivateRoute>} />
      <Route path="/commercial/historique" element={<PrivateRoute roles={["Commercial"]}><Historique /></PrivateRoute>} />

      {/* Profil — accessible à tous les rôles connectés */}
      <Route path="/profil" element={<PrivateRoute roles={["Commercial", "Superviseur", "Administrateur"]}><Profil /></PrivateRoute>} />

      {/* 404 */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}